var path = '/static/assets/khapps/fms_app/partials/farmdetails/equipment/farm_equipment_list_card.html';
var html = "<kh-card cards=\"farmEquipmentsListCard\"></kh-card>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;